export type IEmployeeTableFilterValue = string | string[];

export enum EmployeeStatus {
  ACTIVE = 'active',
  DISABLED = 'disabled',
  PENDING = 'pending',
  SUSPENDED = 'suspended',
  DELETED = 'deleted',
}

export const EMPLOYEE_STATUS_OPTIONS = [
  { value: EmployeeStatus.ACTIVE, label: 'Active' },
  { value: EmployeeStatus.DISABLED, label: 'Ended' },
  { value: EmployeeStatus.PENDING, label: 'Pending' },
  { value: EmployeeStatus.SUSPENDED, label: 'Suspended' },
  { value: EmployeeStatus.DELETED, label: 'Deleted' },
];

export enum EMPLOYEE_EPF_STATUS {
  ALL = 'all',
  ENABLED = 'yes',
  DISABLED = 'no',
}

export const EMPLOYEE_EPF_STATUS_OPTIONS = [
  { value: EMPLOYEE_EPF_STATUS.ENABLED, label: 'Yes' },
  { value: EMPLOYEE_EPF_STATUS.DISABLED, label: 'No' },
];

export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
}

export const GENDER_OPTIONS = [
  { value: Gender.MALE, label: 'Male' },
  { value: Gender.FEMALE, label: 'Female' },
];

export const BANK_OPTIONS = [
  { value: 'BOC', label: 'Bank of Ceylon (BOC)' },
  { value: 'Peoples Bank', label: "People's Bank" },
];

export const EMPLOYMENT_END_REASON_OPTIONS = [
  { value: 'resignation', label: 'Resignation', labelSi: 'ඉල්ලා අස්වීම' },
  { value: 'termination_performance', label: 'Termination – Performance', labelSi: 'කාර්ය සාධනය නිසා සේවයෙන් ඉවත් කිරීම' },
  { value: 'termination_misconduct', label: 'Termination – Misconduct', labelSi: 'විනය කඩ කිරීම් නිසා සේවයෙන් ඉවත් කිරීම' },
  { value: 'end_of_contract', label: 'End of Contract', labelSi: 'ගිවිසුම අවසන් වීම' },
  { value: 'retirement', label: 'Retirement', labelSi: 'විශ්‍රාම ගැන්වීම' },
  { value: 'redundancy', label: 'Redundancy / Position Eliminated', labelSi: 'අතිරික්ත වීම / තනතුර අහෝසි කිරීම' },
  { value: 'other', label: 'Other', labelSi: 'වෙනත්' },
];

// Columns the "Print selected" dialog can put on the PDF. Values match
// EmployeePrintField on the server.
export const EMPLOYEE_PRINT_FIELD_OPTIONS = [
  { value: 'employeeNumber', label: 'Employee Number' },
  { value: 'name', label: 'Full Name' },
  { value: 'nicNumber', label: 'NIC Number' },
  { value: 'baseSalary', label: 'Base Salary' },
  { value: 'epf', label: 'EPF' },
  { value: 'gender', label: 'Gender' },
  { value: 'birthDate', label: 'Birthdate' },
  { value: 'joinedAt', label: 'Joined At' },
  { value: 'phoneNumber', label: 'Phone Number' },
  { value: 'contactPersonName', label: 'Contact Person Name' },
  { value: 'contactPersonPhoneNumber', label: 'Contact Person Phone Number' },
  { value: 'address', label: 'Address' },
  { value: 'bankAccountName', label: 'Bank Account Name' },
  { value: 'bankAccountNumber', label: 'Bank Account Number' },
  { value: 'bank', label: 'Bank' },
];

// Printed on every list unless an admin unticks them.
export const MANDATORY_EMPLOYEE_PRINT_FIELDS = ['employeeNumber', 'name'];

export interface IBankDetails {
  accountName?: string;
  accountNumber?: string;
  bank?: string;
}

export interface INicImage {
  key?: string;
  mimeType?: string;
  uploadedAt?: string;
}

export type IEmployeeTableFilters = {
  generalSearch: string;
  epf: string;
  baseSalary: number | null;
  status: EmployeeStatus;
};

export type IEmployeeTableSort = {
  sortBy: string;
  order: 'asc' | 'desc';
};

export interface IEmployeeListItem {
  _id: string;
  firstName: string;
  lastName?: string;
  employeeNumber: string;
  baseSalary: number;
  epf: boolean;
  nicNumber?: string;
  gender?: Gender;
  phoneNumber?: string;
  joinedAt?: string;
  updatedAt: string;
  status: string;
}

export interface IEmployeeItem {
  _id: string;
  firstName: string;
  lastName?: string;
  employeeNumber: string;
  baseSalary: number;
  epf: boolean;
  nicNumber?: string;
  birthDate?: string;
  gender?: Gender;
  joinedAt?: string;
  phoneNumber?: string;
  contactPersonName?: string;
  contactPersonPhoneNumber?: string;
  address?: string;
  bankDetails?: IBankDetails;
  nicFrontImage?: INicImage;
  nicBackImage?: INicImage;
  status: string;
  employmentEndAt?: string | null;
  employmentEndReason?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface IEmployeeBaseSalaryRange {
  baseSalary: number;
}
